"use client";

import { useState, FormEvent } from "react";
import { subscribeToNewsletter } from "@/app/lib/actions/newsletter";

type Status = "idle" | "loading" | "success" | "error";

interface UseNewsletterFormReturn {
  email: string;
  setEmail: (email: string) => void;
  status: Status;
  message: string;
  handleSubmit: (e: FormEvent) => Promise<void>;
}

export function useNewsletterForm(): UseNewsletterFormReturn {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    
    if (!email.trim()) {
      setStatus("error");
      setMessage("Please enter your email");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setStatus("error");
      setMessage("Please enter a valid email");
      return;
    }

    setStatus("loading");
    
    try {
      const result = await subscribeToNewsletter(email);
      
      if (result.success) {
        setStatus("success");
        setMessage(result.message);
        setEmail("");
      } else {
        setStatus("error");
        setMessage(result.message);
      }
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "";
      if (errorMessage.includes("Failed to find Server Action")) {
        setStatus("error");
        setMessage("Page updated. Please refresh and try again.");
      } else {
        setStatus("error");
        setMessage("Something went wrong. Please try again.");
      }
    }
  };

  return { email, setEmail, status, message, handleSubmit };
}
